// this file was just added as a quick fix so webpack can point to a single entry
// and will bundle up everything
// vendor file will go away in the future
import "./vendor.ts";
import "./Client/Core/app.run.ts";
